import { useMemo } from "react";
import { BUTTON_LABELS, CONFIG_PAGES } from "@miplatform/constants";
import { useRouter } from "@miplatform/hooks";
import { IWorkOrderTemplateListItemResponse } from "@miplatform/types";
import { mdiChevronDown, mdiPencilOutline, mdiTrashCanOutline } from "@mdi/js";
import { useTheme } from "@mui/material";
import { MODULES_CONFIG_PATHS } from "../../../../routes/config/constants";
import { ConfigCard, ConfigMenu } from "../../components";

export const ConfigWorkOrderTemplateCard = ({
  item,
  handleOpenDeleteModal,
  handleUpdateWorkOrderTemplate,
  canDeleteWorkOrderTemplate,
  canUpdateWorkOrderTemplate,
}: {
  item: IWorkOrderTemplateListItemResponse;
  handleOpenDeleteModal: (item: IWorkOrderTemplateListItemResponse) => void;
  handleUpdateWorkOrderTemplate: (
    data: Partial<IWorkOrderTemplateListItemResponse>,
    name?: string
  ) => void;
  canUpdateWorkOrderTemplate: boolean;
  canDeleteWorkOrderTemplate: boolean;
}) => {
  const theme = useTheme();
  const { navigate } = useRouter();
  const navigateToWorkOrderTemplateDetails = () => {
    navigate(
      `${
        MODULES_CONFIG_PATHS[item.module][CONFIG_PAGES.WORK_ORDER_TEMPLATES]
      }/${item.id}`
    );
  };

  const menuActions = useMemo(() => {
    const actions = [];

    if (canUpdateWorkOrderTemplate) {
      actions.push({
        label: BUTTON_LABELS.EDIT,
        action: navigateToWorkOrderTemplateDetails,
        icon: mdiPencilOutline,
      });
    }

    if (canDeleteWorkOrderTemplate) {
      actions.push({
        label: BUTTON_LABELS.DELETE,
        action: () => handleOpenDeleteModal(item),
        icon: mdiTrashCanOutline,
        color: theme.palette.error.main,
      });
    }

    return actions;
  }, [canUpdateWorkOrderTemplate, canDeleteWorkOrderTemplate, item]);

  return (
    <ConfigCard
      title={item.name}
      modifiedOn={item.modifiedOn}
      createdOn={item.createdOn}
      onClick={navigateToWorkOrderTemplateDetails}
      additionalTitleText={
        item.orderTemplateName ? [item.orderTemplateName] : undefined
      }
      menuActions={menuActions}
      customAction={
        <ConfigMenu
          data={[
            {
              label: item.isActive ? "Draft" : "Activate",
              action: () => {
                const data = {
                  id: item.id,
                  modifiedOn: item.modifiedOn,
                  isActive: !item.isActive,
                };
                handleUpdateWorkOrderTemplate(data, item.name);
              },
            },
          ]}
          optionalElement={{
            size: "small",
            title: item.isActive ? "Active" : "Draft",
            color: item.isActive ? "success" : "orange",
            endIcon: { path: mdiChevronDown },
            sx: { width: 85 },
          }}
        />
      }
    />
  );
};
